import React from 'react';
import {Image} from 'antd-mobile'
import errorLink from  '@/assets/images/error-link.png'


const NoMatch = () => <div style={{paddingTop: '88px',textAlign:'center'}}>
                            <Image src={errorLink} width={240} height={160} style={{margin: '0 auto'}}/>
                            <p style={{fontFamily:' SourceHanSansCN-Regular',
                                            fontSize: '18px',
                                            fontWeight: 'normal',
                                            lineHeight: '25px',
                                            letterSpacing: '0px',
                                            color: '#999999',
                                            marginTop: '20px'}}>无效链接</p></div>;

export default NoMatch;
